import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectCurrentUser } from 'store/users/users.selectors'
import { selectUsers } from 'store/admin/admin.selectors'
import { fetchGetUsersRequest } from 'store/admin/admin.actions'

import InvitationHeader from 'components/organisms/InvitationHeader/InvitationHeader'
import { InvitationForm } from 'components/molecules/CustomerForm/InvitationForm'
import UserList from 'components/molecules/UserList'
import Title from 'components/atoms/Title'

const InvitationPage: React.FC = () => {
  const dispatch = useDispatch()
  const currentUser = useSelector(selectCurrentUser)
  const users = useSelector(selectUsers)

  useEffect(() => {
    dispatch(fetchGetUsersRequest())
  }, [dispatch, currentUser])

  return (
    <>
      <div className="container page-content d-flex flex-column flex-grow-1">
        <InvitationHeader />
        <Title text="Форма приглашения" />
        <InvitationForm withoutHeader />
        {users?.length ? (
          <>
            <Title text="Список сотрудников" />
            <UserList users={users} onClick={() => {}} />
          </>
        ) : null}
      </div>
    </>
  )
}

export default InvitationPage
